import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation } from 'react-router-dom';
import moment from "moment"
import { Dialog } from 'primereact/dialog'
import { Tooltip } from 'primereact/tooltip'
import { Sidebar } from 'primereact/sidebar';
import { Skeleton } from 'primereact/skeleton';

import "./index.css"

import SmartFilterImg from "./../../images/smartFilterImg_.png"
import SmartFilterActiveImg from "./../../images/smartFilterActiveImg_.png"
import { Button, Table } from "../../helpers"
import Menu from '../../helpers/Menu'
import MeterGroup from '../../helpers/MeterGroup';

import PMUserName from '../../common/PMUserName';
import PMCompanyName from '../../common/PMCompanyName';
import Loading from '../../common/Loading'
import CopyToClipboard from '../../common/CopyToClipboard';
import ButtonGroup from '../../common/ButtonGroup';

import BuyerPoModal from './Components/BuyerPoModal'
import SellerPoModal from './Components/SellerPoModal'
import QuotationModal from './Components/QuotationModal'
import AddProduct from './Components/AddProduct'
import SearchBar from './Components/SearchBar';
import ReqDetailsModal from './Components/ReqDetailsModal'
import DuplicateBuyerReqDateModal from './Components/DuplicateBuyerReqDateModal'
import EditBuyerReqItemQty from './Components/EditBuyerReqItemQty'
import POPunchModal from './Components/POPunchModal';

import { duplicateBuyerRequirement, deleteBuyerRequirement, getSellerReqsStatusByBuyerReqIds, getLatestBuyerReqByClientPONum } from '../../services/api/buyerReq'

import { raiseToast } from '../../services/redux/reducers/toast/toast';
import { fetchApprovals, fetchCompanyCreditPeriods, fetchMaterialBrands, fetchMaterialCategories, fetchOrderTypesData } from '../../services/redux/reducers/commonThunk';
import { fetchRequirement, fetchMaterialsData, deleteRequirement, updateBuyerRequirementData, updateBuyerRequirementItemsData, setInitialLoad, updateSearchParams, fetchReqRelatedData, resetReqData, setIsSearchVisible } from '../../services/redux/reducers/Requirement/requirement';
import { searchCompanies } from '../../services/api/company';
import { searchIncrementalReqLogs } from '../../services/api/incrementalReqLogs';
import { getNonRoutedSellerPOsInfoBySellerPOs, getPastSellerPOsByCompanyIds } from '../../services/api/sellerPO';
import { searchMaterialMandatoryUseFromStock } from '../../services/api/materialMandatoryUseFromStock';

import { calculateQuoteApprovals, getCompanyShortName, getBuyerPOApprovals, getSellerPOApprovals, getApprovalRequestStatusDetails, getApprovalStatus, getDaysDifference, isMobile } from '../../utils'
import { getPMCompanyConfig } from '../../setup/pmCompanyConfig';
import { DATE_TIME_FORMAT } from '../../constants';


function NewRequirementBuyer() {
    const [isSmartSearchApplicable, setIsSmartSearchApplicable] = useState(false)
    const [visibleQuotes, setVisibleQuotes] = useState(false)
    const [visibleBuyerpo, setVisibleBuyerpo] = useState(false)
    const [visibleSellerpo, setVisibleSellerpo] = useState(false)
    const [visibleAddProduct, setVisibleAddProduct] = useState(false)
    const [visiblePOPunch, setVisiblePOPunch] = useState(false)
    const [selectedReq, setSelectedReq] = useState({})
    const [visibleReqDetails, setVisibleReqDetails] = useState(false)
    const [buyerReqDisplayProducts, setBuyerReqDisplayProducts] = useState([]);
    const [buyerPOStatus , setBuyerPOStatus] = useState([])
    const [sellerReqStatus, setSellerReqStatus] = useState([])
    const [buyerQuoteStatus, setBuyerQuoteStatus] = useState([])
    const [POPunchStatus, setPOPunchStatus] = useState([])
    const [sellerPOStatus, setSellerPOStatus] = useState([])
    const [sellerCompanyDetails, setSellerCompanyDetails] = useState([])
    const [incrementalReqLogs, setIncrementalReqLogs] = useState([])
    const [pastSellerPOsInfo, setPastSellerPOsInfo] = useState([])
    const [nonRoutedSellerPOsInfo, setNonRoutedSellerPOsInfo] = useState([])
    const [materialMandatoryUseFromStock, setMaterialMandatoryUseFromStock] = useState([])

    const [isPageLoading, setIsPageLoading] = useState(false)
    const [visibleDuplicateBuyerReqDate, setVisibleDuplicateBuyerReqDate] = useState(false)
    const [duplicateBuyerReqLoading, setDuplicateBuyerReqLoading] = useState(false)
    const [visibleEditBuyerReqItemQty, setVisibleEditBuyerReqItemQty] = useState(false)

    const requirementActionMenu = useRef(null)

    const dispatch = useDispatch()
    const navigate = useNavigate()

    const isMobileDevice = isMobile()

    const buyerRequirementData = useSelector(state => state.requirements.buyerRequirementData)
    const buyerRequirementItemsData = useSelector(state => state.requirements.buyerRequirementItemsData)
    const materilProductsData = useSelector(state => state.requirements.materialProductsData)
    const isInitialLoad = useSelector(state => state.requirements.isInitialLoad)
    const isLoading = useSelector(state => state.requirements.loading)
    const reqDataLoading = useSelector(state => state.requirements.reqDataLoading)
    const paginationParams = useSelector(state => state.requirements.paginationParams)
    const searchParams = useSelector(state => state.requirements.searchParams)
    const sellerReqData = useSelector(state => state.requirements.sellerReqData)
    const buyerQuoteData = useSelector(state => state.requirements.buyerQuoteData)
    const buyerPOData = useSelector(state => state.requirements.buyerPOData)
    const poPunchData = useSelector(state => state.requirements.poPunchData)
    const poScheduleData = useSelector(state => state.requirements.poScheduleData)
    const sellerPOData = useSelector(state => state.requirements.sellerPOData)
    const piPunchData = useSelector(state => state.requirements.piPunchData)
    const isSearchVisible = useSelector(state => state.requirements.isSearchVisible)
    const isSearchActive = useSelector(state => state.requirements.isSearchActive)

    const approvalInstancesData = useSelector(state => state.requirements.approvalInstancesData)
    const userDetails = useSelector(state => state.userDetails)
    const orderTypes = useSelector(state => state.common.orderTypes)
    const approvals = useSelector((state) => state.common.approvals)
    const companyCreditPeriods = useSelector((state) => state.common.companyCreditPeriods)

    const pmCompanyConfig = getPMCompanyConfig(userDetails.PMCompanyDetails.companyId)
    
    let quotationApprovals = useMemo(() => {
        return approvals?.filter(eachApproval => pmCompanyConfig.quotationApprovalTypeIds.includes(eachApproval.approvalTypeId))
    }, [approvals])

    let POApprovals = useMemo(() => {
        return approvals?.filter(eachApproval => pmCompanyConfig.buyerPOApprovalTypeIds.includes(eachApproval.approvalTypeId))
    }, [approvals])

    let sellerPOApprovals = useMemo(() => {
        return approvals?.filter(eachApproval => pmCompanyConfig.sellerPOApprovalTypeIds.includes(eachApproval.approvalTypeId))
    }, [approvals])
    
    const location = useLocation()

    useEffect(() => {
        getIntialLoadData()

        dispatch(fetchMaterialBrands())
        dispatch(fetchMaterialCategories())
        dispatch(fetchOrderTypesData())
        dispatch(fetchApprovals())
        dispatch(fetchCompanyCreditPeriods())
    }, [])

    const getIntialLoadData = () => {
        const queryParams = new URLSearchParams(location.search)

        if (queryParams.get('docNo')) {
            let requirementParams = {
                ...searchParams,
                ...paginationParams,
                pageNo: 0,
                searchBy: 'reqNo',
                searchText: queryParams.get('docNo'),
                docNo: queryParams.get('docNo'),
                include: [
                    { model: "company", attributes: ["companyName"] },
                    { model: "kam", attributes: ["firstName", "lastName"] },
                    { model: "buyer", attributes: ["firstName", "lastName"] },
                    { model: "buyerCompanyBranch", attributes: ["branchName"] },
                    { model: "pmCompanyBranch", attributes: ["branchName"] }
                ]
            }
            dispatch(fetchRequirement(requirementParams))
            return
        }
        if (isInitialLoad) {
            let toDate = new Date()
            toDate.setHours(23, 59, 0, 0)
            toDate = toDate.toISOString()

            let fromDate = new Date()
            fromDate.setDate(fromDate.getDate() - 30)
            fromDate.setHours(0, 0, 0, 0)
            fromDate = fromDate.toISOString()

            const updatedSearchParams = {
                ...searchParams,
                fromDate: fromDate,
                toDate: toDate
            }

            let requirementParams = {
                ...updatedSearchParams,
                ...paginationParams,
                pageNo: 0,
                include: [
                    { model: "company", attributes: ["companyName", "tags"] },
                    { model: "kam", attributes: ["firstName", "lastName"] },
                    { model: "buyer", attributes: ["firstName", "lastName"] },
                    { model: "buyerCompanyBranch", attributes: ["branchName"] },
                    { model: "pmCompanyBranch", attributes: ["branchName"] }
                ]
            }

            dispatch(updateSearchParams(updatedSearchParams))
            dispatch(fetchRequirement(requirementParams))
            dispatch(setInitialLoad(false))
        }
    }

    useEffect(() => {
        if (buyerRequirementData) {
            let buyerReqIds = buyerRequirementData?.map(eachBuyerRequirement => eachBuyerRequirement.buyerReqId)

            let data = {
                buyerReqIds: buyerReqIds
            }
            dispatch(fetchReqRelatedData(data))
            // dispatch(fetchSellerReq(data))
            // dispatch(fetchBuyerQuotes(data))
            // dispatch(fetchBuyerPOs(data))
            // dispatch(fetchPOPunch(data))
            // dispatch(fetchSellerPO(data))
            // dispatch(fetchPIPunch(data))
        }
    }, [buyerRequirementData])

    useEffect(() => {
        if (buyerRequirementData.length){
            getIncrementalReqLogs()
        }

    }, [buyerRequirementData])

    useEffect(() => {
        if (buyerRequirementItemsData?.length > 0) {
            let buyerReqItemIds = buyerRequirementItemsData?.map(eachBuyerRequirementItem => eachBuyerRequirementItem?.buyerReqItemId)
            let materialIdParams = {
                buyerReqItemsIds: buyerReqItemIds
            }
            dispatch(fetchMaterialsData(materialIdParams))
        }
    }, [buyerRequirementItemsData])

    useEffect(() => {
        if (buyerRequirementItemsData.length){
            getMaterialMandatoryUseFromStock()
        }
    }, [buyerRequirementItemsData])

    useEffect(() => {
        if (buyerRequirementData.length > 0){
            getSellerReqStatus()
        }
    }, [buyerRequirementData])

    useEffect(() => {
        if(poScheduleData?.poSchedules){
            getPOPunchStatus()
        }
    }, [poScheduleData, poPunchData])

    useEffect(() => {
        if (sellerPOData.sellerPOs?.length){
            getPastSellerPOs()
        }
    }, [sellerPOData])

    /*useEffect(() => {
        if (sellerPOData.sellerPOs?.length){
            getNonRoutedSellerPOs()
        }
    }, [sellerPOData])*/

    useEffect(() => {
        if (buyerRequirementData.length && buyerRequirementItemsData.length && buyerQuoteData?.buyerQuotes && approvalInstancesData && !reqDataLoading && !isLoading && materilProductsData.length){
            getBuyerQuoteStatus()
        }
    }, [buyerRequirementData, buyerRequirementItemsData, buyerQuoteData, sellerReqData, approvalInstancesData, materilProductsData])

    useEffect(() => {
        if (buyerRequirementData.length && buyerPOData?.buyerPOs && approvalInstancesData && !reqDataLoading && !isLoading){
            getBuyerPOStatus()
        }
    }, [buyerRequirementData, buyerPOData, buyerQuoteData, approvalInstancesData])

    useEffect(() => {
        if (buyerRequirementData.length && buyerRequirementItemsData.length && sellerPOData?.sellerPOs && buyerPOData?.buyerPOs.length && buyerQuoteData?.buyerQuotes.length && approvalInstancesData && !reqDataLoading && !isLoading){
            getSellerPOStatus()
        }
    }, [buyerRequirementData, buyerRequirementItemsData, buyerQuoteData, buyerPOData, sellerPOData, approvalInstancesData, materilProductsData])

    const handleEditBuyerReqItemQty = async () => {
        const buyerReqId = selectedReq.buyerReqId

        let allProducts = []
        buyerRequirementItemsData.filter((eachReqItem) => {
            if (eachReqItem.buyerReqId === buyerReqId) {
                materilProductsData.find((eachProduct) => {
                    if (eachProduct.buyerReqItemId === eachReqItem.buyerReqItemId) {
                        const relatedBuyerRateContractId = eachReqItem.buyerRateContractId
                        const itemQty = eachReqItem.qty
                        const relatedOrderTypeId = selectedReq.orderTypeId
                        let relatedOrderType = {}
                        if (relatedOrderTypeId){
                            relatedOrderType = orderTypes.find(eachOrderType => eachOrderType.orderTypeId === relatedOrderTypeId)
                        }
                        allProducts.push({ ...eachProduct, buyerRateContractId: relatedBuyerRateContractId, orderTypeId: relatedOrderTypeId, orderType: relatedOrderType.orderType, docNo: selectedReq.docNo, qty: itemQty })
                    }
                })
            }
        })
        setBuyerReqDisplayProducts(allProducts)
        setVisibleEditBuyerReqItemQty(true)
    }

    const getSellerReqStatus = async ()=>{
        let buyerReqIds = buyerRequirementData.map(eachBuyerRequirement => eachBuyerRequirement.buyerReqId)
        let sellerReqStatus = await getSellerReqsStatusByBuyerReqIds({buyerReqIds: buyerReqIds})

        if (sellerReqStatus.failure){
            return dispatch(raiseToast({ severity: 'error', detail: sellerReqStatus.data.error, life: 3000 }))
        }

        setSellerReqStatus(sellerReqStatus.data)
    }

    const getBuyerQuoteStatus = async () => {
        let buyerReqIds = buyerRequirementData.map(eachBuyerRequirement => eachBuyerRequirement.buyerReqId)

        let updatedBuyerQuotes = []
        buyerQuoteData.buyerQuotes.map(eachBuyerQuote => {
            const relatedBuyerReq = buyerRequirementData.find(eachBuyerReq => eachBuyerReq.buyerReqId === eachBuyerQuote.buyerReqId)
            const relatedActiveBuyerPOs = buyerPOData.buyerPOs.filter(eachBuyerPO => eachBuyerPO.buyerQuoteId === eachBuyerQuote.buyerQuoteId && [3, 4].includes(eachBuyerPO.statusId))
            const relatedBuyerQuoteUpdatedUser = userDetails.PMCompanyDetails.companyUsers.find(eachUser => eachUser.userId === eachBuyerQuote.updatedBy)

            let relatedBuyerReqItems = []
            if (relatedBuyerReq){
                buyerRequirementItemsData.map(eachBuyerReqItem => {
                    if (eachBuyerReqItem.buyerReqId === relatedBuyerReq.buyerReqId){
                        const relatedMaterial = materilProductsData.find(eachMaterial => eachMaterial.buyerReqItemId === eachBuyerReqItem.buyerReqItemId)
                        relatedBuyerReqItems.push({...eachBuyerReqItem, categoryId: relatedMaterial?.categoryId, brandId: relatedMaterial?.brandId})
                    }
                })
            }
            const relatedBuyerQuoteItems = buyerQuoteData.buyerQuoteItems.filter(eachBuyerQuoteItem => eachBuyerQuoteItem.buyerQuoteId === eachBuyerQuote.buyerQuoteId)
            const relatedApprovalInstances = approvalInstancesData.filter(eachApprovalInstance => eachApprovalInstance.docNo === eachBuyerQuote.docNo)

            let data = {
                buyerReq: relatedBuyerReq,
                buyerReqItems: relatedBuyerReqItems,
                quotationApprovals: quotationApprovals,
                buyerQuote: eachBuyerQuote,
                buyerQuoteItems: relatedBuyerQuoteItems,
                updatedByUserDetails: relatedBuyerQuoteUpdatedUser
            }

            const requiredApprovals = calculateQuoteApprovals(data)
            let updatedBuyerQuote = {...eachBuyerQuote}
            const approvalRequestStatusDetails = getApprovalRequestStatusDetails({
                updatedRequiredApprovals: requiredApprovals, 
                approvalInstances: relatedApprovalInstances, 
                approvals: quotationApprovals, 
                pmBranchId: updatedBuyerQuote.pmBranchId, 
                buyerQuote: updatedBuyerQuote
            })
            
            let {pendingApprovalsExist, allApprovalsApproved} = getApprovalStatus(approvalRequestStatusDetails)

            if(relatedActiveBuyerPOs.length){
                pendingApprovalsExist = false
            }

            updatedBuyerQuote.pendingApprovalsExist = pendingApprovalsExist
            updatedBuyerQuote.allApprovalsApproved = allApprovalsApproved
            
            updatedBuyerQuotes.push(updatedBuyerQuote)
        })

        let buyerQuoteStatus = []
        buyerReqIds.map(eachBuyerReqId => {
            const relatedBuyerReqItems = buyerRequirementItemsData.filter(eachBuyerReqItem => eachBuyerReqItem.buyerReqId === eachBuyerReqId)
            const relatedBuyerQuoteItems = buyerQuoteData.buyerQuoteItems.filter(eachBuyerQuoteItem => eachBuyerQuoteItem.buyerReqId === eachBuyerReqId)

            let activeQuotationCount = 0
            let pendingQuotationCount = 0
            let noQuotationCount = 0

            let filteredBuyerReqItems = []
            relatedBuyerReqItems.map(eachBuyerReqItem => {
                const relatedSellerReqItem = sellerReqData.sellerReqItems.find(eachSellerReqItem => eachSellerReqItem.buyerReqItemId === eachBuyerReqItem.buyerReqItemId && eachSellerReqItem.statusId === 1)
                if (relatedSellerReqItem){
                    filteredBuyerReqItems.push(eachBuyerReqItem)
                }
            })

            if (filteredBuyerReqItems.length === 0){
                noQuotationCount = relatedBuyerReqItems.length
            }

            filteredBuyerReqItems.map(eachBuyerReqItem => {
                const buyerQuoteItemsForReqItem = relatedBuyerQuoteItems.filter(eachBuyerQuoteItem => eachBuyerQuoteItem.buyerReqItemId === eachBuyerReqItem.buyerReqItemId && eachBuyerQuoteItem.statusId === 1)
    
                if (buyerQuoteItemsForReqItem.length > 0) {
                    let foundActiveQuote = false
                    let hasPendingQuote = false
        
                    for (let eachBuyerQuoteItem of buyerQuoteItemsForReqItem) {
                        const relatedBuyerQuote = updatedBuyerQuotes.find(eachBuyerQuote => eachBuyerQuote.buyerQuoteId === eachBuyerQuoteItem.buyerQuoteId)

                        if (!relatedBuyerQuote.pendingApprovalsExist) {
                            activeQuotationCount += 1
                            foundActiveQuote = true
                            break
                        }
        
                        if (relatedBuyerQuote.pendingApprovalsExist) {
                            hasPendingQuote = true
                        }
                    }
        
                    if (!foundActiveQuote && hasPendingQuote) {
                        pendingQuotationCount += 1
                    }
                } else {
                    noQuotationCount += 1
                }
            })
            let eachBuyerReqQuotationStatus = {
                buyerReqId: eachBuyerReqId,
                totalBuyerReqItems: filteredBuyerReqItems.length ? filteredBuyerReqItems.length : relatedBuyerReqItems.length,
                activeQuotationCount: activeQuotationCount,
                pendingQuotationCount: pendingQuotationCount,
                noQuotationCount: noQuotationCount
            }
            buyerQuoteStatus.push(eachBuyerReqQuotationStatus)
        })

        setBuyerQuoteStatus(buyerQuoteStatus)
    }

    const getBuyerPOStatus = async () => {
        let buyerReqIds = buyerRequirementData.map(eachBuyerRequirement => eachBuyerRequirement.buyerReqId)
        // let buyerPOStatusRes = await getBuyerPOStatusByBuyerReqIds({buyerReqIds: buyerReqIds})

        // if (buyerPOStatusRes.failure){
        //     return dispatch(raiseToast({ severity: 'error', detail: buyerPOStatusRes.data.error, life: 3000 }))
        // }

        let updatedBuyerPOs = []
        buyerPOData.buyerPOs.map(eachBuyerPO => {
            const relatedBuyerReq = buyerRequirementData.find(eachBuyerReq => eachBuyerReq.buyerReqId === eachBuyerPO.buyerReqId)
            let relatedBuyerReqItems = []
            if (relatedBuyerReq){
                relatedBuyerReqItems = buyerRequirementItemsData.filter(eachBuyerReqItem => eachBuyerReqItem.buyerReqId === relatedBuyerReq.buyerReqId)
            }
            const relatedApprovalInstances = approvalInstancesData.filter(eachApprovalInstance => eachApprovalInstance.docNo === eachBuyerPO.docNo)

            let data = {
                buyerReq: relatedBuyerReq,
                buyerPO: {...eachBuyerPO},
                POApprovals: POApprovals
            }

            const requiredApprovals = getBuyerPOApprovals(data)
            let newBuyerPO = {...eachBuyerPO}

            const approvalRequestStatusDetails = getApprovalRequestStatusDetails({
                updatedRequiredApprovals: requiredApprovals, 
                approvalInstances: relatedApprovalInstances, 
                approvals: POApprovals, 
                pmBranchId: newBuyerPO.pmBranchId, 
                buyerPO: newBuyerPO
            })
            
            const {pendingApprovalsExist, allApprovalsApproved} = getApprovalStatus(approvalRequestStatusDetails)

            newBuyerPO.pendingApprovalsExist = pendingApprovalsExist
            newBuyerPO.allApprovalsApproved = allApprovalsApproved
            
            updatedBuyerPOs.push(newBuyerPO)
        })
            
        let buyerPOStatus = []
        buyerReqIds.map(eachBuyerReqId => {
            const relatedBuyerReqItems = buyerRequirementItemsData.filter(eachBuyerReqItem => eachBuyerReqItem.buyerReqId === eachBuyerReqId)
            const relatedBuyerPOItems = buyerPOData.buyerPOItems.filter(eachBuyerPOItem => eachBuyerPOItem.buyerReqId === eachBuyerReqId)

            let activePOCount = 0
            let pendingPOCount = 0
            let noPOCount = 0

            let filteredBuyerReqItems = []
            relatedBuyerReqItems.map(eachBuyerReqItem => {
                const relatedBuyerQuoteItem = buyerQuoteData.buyerQuoteItems.find(eachBuyerQuoteItem => eachBuyerQuoteItem.buyerReqItemId === eachBuyerReqItem.buyerReqItemId && eachBuyerQuoteItem.statusId === 1)
                if (relatedBuyerQuoteItem){
                    filteredBuyerReqItems.push(eachBuyerReqItem)
                }
            })

            if (filteredBuyerReqItems.length === 0){
                noPOCount = relatedBuyerReqItems.length
            }

            filteredBuyerReqItems.map(eachBuyerReqItem => {
                const buyerPOItemsForReqItem = relatedBuyerPOItems.filter(eachBuyerPOItem => eachBuyerPOItem.buyerReqItemId === eachBuyerReqItem.buyerReqItemId && eachBuyerPOItem.statusId === 3)
    
                if (buyerPOItemsForReqItem.length > 0) {
                    let foundActivePO = false
                    let hasPendingPO = false
        
                    for (let eachBuyerPOItem of buyerPOItemsForReqItem) {
                        const relatedBuyerPO = updatedBuyerPOs.find(eachBuyerPO => eachBuyerPO.buyerPOId === eachBuyerPOItem.buyerPOId)

                        if (!relatedBuyerPO.pendingApprovalsExist) {
                            activePOCount += 1
                            foundActivePO = true
                            break
                        }
        
                        if (relatedBuyerPO.pendingApprovalsExist) {
                            hasPendingPO = true
                        }
                    }
        
                    if (!foundActivePO && hasPendingPO) {
                        pendingPOCount += 1
                    }
                } else {
                    noPOCount += 1
                }
            })
            let eachBuyerReqPOStatus = {
                buyerReqId: eachBuyerReqId,
                totalBuyerReqItems: filteredBuyerReqItems.length ? filteredBuyerReqItems.length : relatedBuyerReqItems.length,
                activePOCount: activePOCount,
                pendingPOCount: pendingPOCount,
                noPOCount: noPOCount
            }
            buyerPOStatus.push(eachBuyerReqPOStatus)
        })

        setBuyerPOStatus(buyerPOStatus)
    }

    const getPOPunchStatus = () => {
        const {poSchedules, poScheduleItems} = poScheduleData
        const {poPunchItems} = poPunchData
        const {buyerPOItems} = buyerPOData

        const poPunchStatus = []
        const buyerReqIds = buyerRequirementData.map(eachBuyerRequirement => eachBuyerRequirement.buyerReqId)

        buyerReqIds.map(eachBuyerReqId => {
            const relatedPOSchedules = poSchedules.filter(eachSchedule => eachSchedule.buyerReqId === eachBuyerReqId)
            const relatedPOScheduleItems = poScheduleItems.filter(eachScheduleItem => eachScheduleItem.buyerReqId === eachBuyerReqId)

            const eachPOPunchStatus = {
                buyerReqId: eachBuyerReqId,
                scheduleDateStatus: "green"
            }

            if(!relatedPOSchedules.length){
                eachPOPunchStatus.scheduleDateStatus = "red"
            } else {
                let allocateBatchToday = false
                let isBatchAllocationPending = false

                relatedPOScheduleItems.forEach(eachScheduleItem => {
                    const relatedBuyerPOItem = buyerPOItems.find(eachBuyerPOItem => eachBuyerPOItem.buyerPOItemId === eachScheduleItem.buyerPOItemId)
                    const relatedPOPunchItem = poPunchItems.find(eachPOPunchItem => eachPOPunchItem.poScheduleItemId === eachScheduleItem.poScheduleItemId)
    
                    if(!relatedPOPunchItem){
                        const leadTime = relatedBuyerPOItem.leadTime || 0
                        const alertDate = moment(eachScheduleItem.scheduledDate).subtract(leadTime, "days")
                        const todayDate = moment(new Date(), "YYYY-MM-DD")

                        const dateDifference = getDaysDifference(alertDate, new Date())

                        if(alertDate.isSame(todayDate)){
                            allocateBatchToday = true
                        }
                        if(alertDate.isBefore(todayDate)){
                            isBatchAllocationPending = true
                        }
                    }
                })

                if(isBatchAllocationPending){
                    eachPOPunchStatus.scheduleDateStatus = "red"
                } else if(allocateBatchToday){
                    eachPOPunchStatus.scheduleDateStatus = "yellow"
                }
            }

            poPunchStatus.push(eachPOPunchStatus)
        })
        
        setPOPunchStatus(poPunchStatus)
    }

    const getSellerPOStatus = async () => {
        let buyerReqIds = buyerRequirementData.map(eachBuyerRequirement => eachBuyerRequirement.buyerReqId)

        let sellerCompanyIds = sellerPOData.sellerPOs.map(eachSellerPO => eachSellerPO.companyId)
        let companyDetailsRes = await searchCompanies({companyIds: sellerCompanyIds, paginator: false})

        if (companyDetailsRes.failure){
            return dispatch(raiseToast({ severity: 'error', detail: companyDetailsRes.data.error, life: 3000 }))
        }

        let updatedSellerPOs = []
        sellerPOData.sellerPOs.map(eachSellerPO => {
            const relatedBuyerPO = buyerPOData.buyerPOs.find(eachBuyerPO => eachBuyerPO.buyerPOId === eachSellerPO.buyerPOId)
            const relatedBuyerPOItems = buyerPOData.buyerPOItems.filter(eachPOItem => eachPOItem.buyerPOId === eachSellerPO.buyerPOId)
            const relatedBuyerQuoteItems = buyerQuoteData.buyerQuoteItems.filter(eachBuyerQuoteItem => eachBuyerQuoteItem.buyerQuoteId === relatedBuyerPO.buyerQuoteId)
            const relatedSellerPOItems = sellerPOData.sellerPOItems.filter(eachSellerPOItem => eachSellerPOItem.sellerPOId === eachSellerPO.sellerPOId)
            const relatedSellerPIPunch = piPunchData.sellerPIPunch.filter(eachSellerPIPunch => eachSellerPIPunch.sellerPOId === eachSellerPO.sellerPOId)
            const relatedSellerCompanyDetails = companyDetailsRes.data.data.find(eachCompany => eachCompany.companyId === eachSellerPO.companyId)
            const relatedApprovalInstances = approvalInstancesData.filter(eachApprovalInstance => eachApprovalInstance.docNo === eachSellerPO.docNo)
            const relatedBuyerReq = buyerRequirementData.find(eachBuyerReq => eachBuyerReq.buyerReqId === eachSellerPO.buyerReqId)
            let relatedNonRoutedSellerPOsInfo = {}
            if (nonRoutedSellerPOsInfo.length){
                relatedNonRoutedSellerPOsInfo = nonRoutedSellerPOsInfo.find(eachNonRoutedSellerPO => eachNonRoutedSellerPO.companyId === eachSellerPO.companyId)
            }

            const relatedSellerReqItems = sellerReqData.sellerReqItems.filter(eachSellerReqItem => eachSellerReqItem.buyerReqId === eachSellerPO.buyerReqId)

            let updatedSellerPO = {...eachSellerPO}

            let data = {
                POApprovals: sellerPOApprovals,
                sellerPO: eachSellerPO,
                sellerPOItems: relatedSellerPOItems,
                sellerCompanyDetails: relatedSellerCompanyDetails,
                companyCreditPeriods: companyCreditPeriods,
                buyerQuoteItems: relatedBuyerQuoteItems,
                sellerPIPunch: relatedSellerPIPunch,
                materialMasterData: materilProductsData,
                buyerReq: relatedBuyerReq,
                buyerPOItems: relatedBuyerPOItems,
                nonRoutedSellerPOsInfo: relatedNonRoutedSellerPOsInfo,
                sellerReqItems: relatedSellerReqItems,
                sellerReqs: sellerReqData.sellerReqs,
                materialMandatoryUseFromStock: materialMandatoryUseFromStock
            }

            const requiredApprovals = getSellerPOApprovals(data)

            const approvalRequestStatusDetails = getApprovalRequestStatusDetails({
                updatedRequiredApprovals: requiredApprovals, 
                approvalInstances: relatedApprovalInstances, 
                approvals: sellerPOApprovals, 
                pmBranchId: updatedSellerPO.pmBranchId, 
                sellerPO: updatedSellerPO
            })

            const {pendingApprovalsExist, allApprovalsApproved} = getApprovalStatus(approvalRequestStatusDetails)

            updatedSellerPO.pendingApprovalsExist = pendingApprovalsExist
            updatedSellerPO.allApprovalsApproved = allApprovalsApproved

            if (relatedSellerPIPunch.length){
                updatedSellerPO.pendingApprovalsExist = false
            }

            updatedSellerPOs.push(updatedSellerPO)
        })
        
        let sellerPOStatus = []
        buyerReqIds.map(eachBuyerReqId => {
            const relatedBuyerReqItems = buyerRequirementItemsData.filter(eachBuyerReqItem => eachBuyerReqItem.buyerReqId === eachBuyerReqId)
            const relatedSellerPOItems = sellerPOData.sellerPOItems.filter(eachBuyerQuoteItem => eachBuyerQuoteItem.buyerReqId === eachBuyerReqId)

            let filterBuyerReqItems = []
            let activePOCount = 0
            let pendingPOCountWithPendingApproval = 0
            let pendingPOCountWithUnSentEmail = 0
            let noPOCount = 0

            relatedBuyerReqItems.map(eachBuyerReqItem => {
                const relatedBuyerPOItem = buyerPOData.buyerPOItems.find(eachBuyerPOItem => eachBuyerPOItem.buyerReqItemId === eachBuyerReqItem.buyerReqItemId)
                if (relatedBuyerPOItem){
                    filterBuyerReqItems.push(eachBuyerReqItem)
                }
            })

            if (filterBuyerReqItems.length === 0){
                noPOCount = relatedBuyerReqItems.length
            }

            /*filterBuyerReqItems.map(eachBuyerReqItem => {
                const sellerPOItemsForReqItem = relatedSellerPOItems.filter(eachSellerPOItem => eachSellerPOItem.buyerReqItemId === eachBuyerReqItem.buyerReqItemId && eachSellerPOItem.statusId === 3)
        
                if (sellerPOItemsForReqItem.length > 0) {
                    let foundActivePO = false
                    let hasPendingPO = false
        
                    for (let eachSellerPOItem of sellerPOItemsForReqItem) {
                        const relatedSellerPO = updatedSellerPOs.find(eachSellerPO => eachSellerPO.sellerPOId === eachSellerPOItem.sellerPOId)

                        if (!relatedSellerPO.pendingApprovalsExist) {
                            activePOCount += 1
                            foundActivePO = true
                            break
                        }
        
                        if (relatedSellerPO.pendingApprovalsExist) {
                            hasPendingPO = true
                        }
                    }
        
                    if (!foundActivePO && hasPendingPO) {
                        pendingPOCount += 1
                    }
                } else {
                    noPOCount += 1
                }
            })*/

            filterBuyerReqItems.map(eachBuyerReqItem => {
                const sellerPOItemsForReqItem = relatedSellerPOItems.filter(eachSellerPOItem => eachSellerPOItem.buyerReqItemId === eachBuyerReqItem.buyerReqItemId && eachSellerPOItem.statusId === 3)
        
                if (sellerPOItemsForReqItem.length > 0) {
                    let hasPendingPO = false
                    let emailNotSent = false
        
                    for (let eachSellerPOItem of sellerPOItemsForReqItem) {
                        const relatedSellerPO = updatedSellerPOs.find(eachSellerPO => eachSellerPO.sellerPOId === eachSellerPOItem.sellerPOId)
        
                        if (relatedSellerPO.pendingApprovalsExist) {
                            hasPendingPO = true
                        }
                        if(!relatedSellerPO.emailSent){
                            emailNotSent = true
                        }
                    }
        
                    if (!emailNotSent && !hasPendingPO) {
                        activePOCount += 1
                    } else if(hasPendingPO){
                        pendingPOCountWithPendingApproval += 1
                    } else if(emailNotSent){
                        pendingPOCountWithUnSentEmail += 1
                    }
                    console.log("activePOCount", activePOCount, pendingPOCountWithUnSentEmail, pendingPOCountWithPendingApproval, emailNotSent, hasPendingPO)
                } else {
                    noPOCount += 1
                }
            })

            /*filterBuyerReqItems.map(eachBuyerReqItem => {
                const relatedSellerPOs = updatedSellerPOs.filter(eachSellerPO => eachSellerPO.buyerReqId === eachBuyerReqItem.buyerReqId)
                if (relatedSellerPOs.length > 0) {
                    for (let eachSellerPO of relatedSellerPOs) {
                        if (eachSellerPO.pendingApprovalsExist) {
                            pendingPOCountWithPendingApproval += 1
                        }
                        else if(!eachSellerPO.emailSent){
                            pendingPOCountWithUnSentEmail += 1
                        }
                        else{
                            activePOCount += 1
                        }
                    }
                } else {
                    noPOCount += 1
                }
            })*/
            
            let eachBuyerReqSellerPOStatus = {
                buyerReqId: eachBuyerReqId,
                totalBuyerReqItems: filterBuyerReqItems.length ? filterBuyerReqItems.length : relatedBuyerReqItems.length,
                activePOCount: activePOCount,
                pendingPOCountWithPendingApproval: pendingPOCountWithPendingApproval,
                pendingPOCountWithUnSentEmail: pendingPOCountWithUnSentEmail,
                noPOCount: noPOCount
            }
            sellerPOStatus.push(eachBuyerReqSellerPOStatus)
        })
        setSellerPOStatus(sellerPOStatus)
        console.log("sellerPOStatus", sellerPOStatus)
        setSellerCompanyDetails(companyDetailsRes.data.data)
    }

    const getIncrementalReqLogs = async () => {
        const docNos = buyerRequirementData.map(eachBuyerReq => eachBuyerReq.docNo)
        const incrementalReqLogRes = await searchIncrementalReqLogs({docNos: docNos, paginator: false})

        if (incrementalReqLogRes.failure){
            return  dispatch(raiseToast({ severity: 'error', summary: 'Incremental Req Log', detail: incrementalReqLogRes.data.error }))
        }

        setIncrementalReqLogs(incrementalReqLogRes.data)
    }

    const getPastSellerPOs = async () => {
        const companyIds = sellerPOData.sellerPOs.map(eachSellerPO => eachSellerPO.companyId)
        
        if (companyIds.length){
            const pastSellerPOsRes = await getPastSellerPOsByCompanyIds({companyIds: companyIds})

            if (pastSellerPOsRes.failure){
                return dispatch(raiseToast({ severity: 'error', summary: "Past Seller POs", detail: pastSellerPOsRes.data.error, life: 3000 }))
            }

            setPastSellerPOsInfo(pastSellerPOsRes.data.pastSellerPOsInfo)
        }
    }

    const getNonRoutedSellerPOs = async () => {
        if (sellerPOData.sellerPOs.length){
            const nonRoutedSellerPORes = await getNonRoutedSellerPOsInfoBySellerPOs({sellerPOs: sellerPOData.sellerPOs})

            if (nonRoutedSellerPORes.failure){
                return dispatch(raiseToast({ severity: 'error', summary: "Non Routed Seller POs", detail: nonRoutedSellerPORes.data.error, life: 3000 }))
            }
            setNonRoutedSellerPOsInfo(nonRoutedSellerPORes.data)
        }
    }

    const getMaterialMandatoryUseFromStock = async () => {
        const materialIds = buyerRequirementItemsData.map(eachBuyerReqItem => eachBuyerReqItem.materialId)
        const materialMandatoryUseFromStockRes = await searchMaterialMandatoryUseFromStock({materialIds, paginator: false})
        if(materialMandatoryUseFromStockRes.failure){
            return dispatch(raiseToast({severity:'error', summary:'Mandatory material use from stock',  detail: materialMandatoryUseFromStockRes.data.error, life: 3000}))
        }

        setMaterialMandatoryUseFromStock(materialMandatoryUseFromStockRes.data.data)
    }

    const handlePageChange = async (e) => {
        let requirementParams = {}
        if (isSmartSearchApplicable){
            requirementParams = {
                ...paginationParams,
                pageNo: e.page + 1,
                isSmartSearchApplicable: true,
            }
        } else{
            requirementParams = {
                ...searchParams,
                paginator: true,
                pageNo: e.page + 1,
                recordsPerPage: e.rows,
                limitedPagination: true,
                getCount: false,
                include: [
                    { model: "company", attributes: ["companyName", "tags"] },
                    { model: "kam", attributes: ["firstName", "lastName"] },
                    { model: "buyer", attributes: ["firstName", "lastName"] },
                    { model: "buyerCompanyBranch", attributes: ["branchName"] },
                    { model: "pmCompanyBranch", attributes: ["branchName"] }
                ]
            }
        }

        if (requirementParams.searchBy !== "all" && requirementParams.searchText) {
            requirementParams[requirementParams.searchBy] = requirementParams.searchText.trim()
        }
        dispatch(fetchRequirement(requirementParams))
        dispatch(resetReqData())
    }

    const handleDuplicateBuyerReqDateCancellation = () => {
        setVisibleDuplicateBuyerReqDate(false);
    }

    const handleDuplicateBuyerRequirement = async () => {
        if (window.confirm("Do you want to duplicate requirement")) {
            setVisibleDuplicateBuyerReqDate(false)
            let duplicateBuyerReqResponse = await duplicateBuyerRequirement(selectedReq)
            const duplicateBuyerReqData = duplicateBuyerReqResponse.data.dataValues
            const duplicateBuyerReqItems = duplicateBuyerReqResponse.data.buyerReqItems

            if (duplicateBuyerReqResponse.failure) {
                return dispatch(raiseToast({ severity: 'error', detail: duplicateBuyerReqResponse.data.error, life: 3000 }))
            }
            const { buyerReqItems, ...relatedBuyerRequirement } = selectedReq
            const duplicateRequirementData = {
                ...relatedBuyerRequirement,
                buyerReqId: duplicateBuyerReqData.buyerReqId,
                docNo: duplicateBuyerReqData.docNo,
                fileNo: duplicateBuyerReqData.fileNo,
                createdAt: duplicateBuyerReqData.createdAt,
                updatedAt: duplicateBuyerReqData.updatedAt,
                'kam.firstName': userDetails.userNameDetails.firstName,
                'kam.lastName': userDetails.userNameDetails.lastName
            }
            dispatch(updateBuyerRequirementData([...buyerRequirementData, duplicateRequirementData]));
            dispatch(updateBuyerRequirementItemsData([...buyerRequirementItemsData, ...duplicateBuyerReqItems]))
            setDuplicateBuyerReqLoading(false)
            return dispatch(raiseToast({ severity: 'success', detail: "Successfully duplicated requirement", life: 3000 }))
        }
        setDuplicateBuyerReqLoading(false)
    }

    const handleDeleteBuyerRequirement = async () => {
        const relatedBuyerQuotes = buyerQuoteData?.buyerQuotes?.filter(eachBuyerQuote => (eachBuyerQuote?.buyerReqId === selectedReq?.buyerReqId && eachBuyerQuote?.statusId === 1))

        if (relatedBuyerQuotes.length === 0) {
            if (window.confirm(`Are you sure you want to delete this requirement? ${selectedReq?.docNo}`)) {
                setIsPageLoading(true)

                const { buyerReqId } = selectedReq
                let deleteBuyerReqResponse = await deleteBuyerRequirement(buyerReqId)
                if (deleteBuyerReqResponse.failure) {
                    setIsPageLoading(false)
                    return dispatch(raiseToast({ severity: 'error', summary: 'Buyer req response', detail: deleteBuyerReqResponse.data.error, life: 3000 }))
                } else {
                    setIsPageLoading(false)

                    const updatedRequirement = buyerRequirementData.filter(each => each.buyerReqId !== buyerReqId)
                    dispatch(deleteRequirement(updatedRequirement))
                    return dispatch(raiseToast({ severity: 'warn', detail: "Requirement is deleted!", life: 3000 }))
                }
            }
        } else {
            return dispatch(raiseToast({ severity: 'error', detail: "Can't delete the requirement. There is currently an active buyer quote", life: 3000 }))
        }
    }

    const handleAddIncrementalReq = async () => {
        const relatedBuyerPO = buyerPOData.buyerPOs.find(eachBuyerPO => eachBuyerPO.buyerReqId === selectedReq.buyerReqId && [3, 4].includes(eachBuyerPO.statusId))

        if (!relatedBuyerPO || (relatedBuyerPO && !relatedBuyerPO.clientPONum)){
            return dispatch(raiseToast({ severity: 'error', detail: 'Cannot add incremental req as clientPONum is not present for this requirement.' }))
        }

        setIsPageLoading(true)

        const latestIncrementalBuyerReqRes = await getLatestBuyerReqByClientPONum({clientPONum: relatedBuyerPO.clientPONum})
        if(latestIncrementalBuyerReqRes.failure){
            setIsPageLoading(false)
            return dispatch(raiseToast({ severity: 'error', detail: latestIncrementalBuyerReqRes.data.error }))
        }
        
        setIsPageLoading(false)

        if(latestIncrementalBuyerReqRes.data){
            window.open(`/postrequirement?buyerReqId=${latestIncrementalBuyerReqRes.data.buyerReqId}`, "_self")
        } else {
            window.open(`/postrequirement?buyerReqId=${selectedReq.buyerReqId}`, "_self")
        }

        //window.open(`/postrequirement?buyerReqId=${selectedReq.buyerReqId}`, "_self")
    }

    let isSelectedReqIncrementalReq = false
    let isAddIncrementalReqVisible = false

    if (selectedReq["company.tags"]?.canDoIncrementalReq){
        isAddIncrementalReqVisible = true
    }

    if (selectedReq.buyerReqId){
        const relatedIncrementalReqLog = incrementalReqLogs.find(eachIncrementalReqLog => eachIncrementalReqLog.reqNo === selectedReq.docNo || eachIncrementalReqLog.oldPRNo === selectedReq.clientReqNo)
        if (relatedIncrementalReqLog){
            isSelectedReqIncrementalReq = true
        }
    }

    const actionMenuItems = [
        {
            label: 'Add Product',
            icon: 'pi pi-cart-plus',
            permissions: [2],
            disabled: isSelectedReqIncrementalReq,
            command: () => { setVisibleAddProduct(true) }
        },
        {
            label: 'Add Incremental Req',
            icon: 'pi pi-cart-plus',
            permissions: [2],
            command: () => { handleAddIncrementalReq() },
            visible: isAddIncrementalReqVisible
        },
        {
            label: 'Duplicate',
            icon: 'pi pi-clone',
            permissions: [3],
            disabled: isSelectedReqIncrementalReq,
            command: () => { setVisibleDuplicateBuyerReqDate(true) }
        },
        {
            label: 'Edit Material Qty',
            icon: 'pi pi-file-edit',
            permissions: [2],
            disabled: isSelectedReqIncrementalReq,
            command: () => { handleEditBuyerReqItemQty() }
        },
        {
            label: 'Delete',
            icon: 'pi pi-trash',
            permissions: [4],
            disabled: isSelectedReqIncrementalReq,
            command: () => { handleDeleteBuyerRequirement() },
            className: 'trash-menu-btn'
        }
    ]

    const handlePOPunchClick = (row) => {
        setSelectedReq({ ...row })
        setVisiblePOPunch(true)
    }

    const sendReqTemplate = (row) => {
        let relatedSellerReqStatus = sellerReqStatus.filter(eachReqStatus => eachReqStatus.buyerReqId == row.buyerReqId)
        let relatedBuyerReqItems = buyerRequirementItemsData.filter(eachBuyerReqItem => eachBuyerReqItem.buyerReqId == row.buyerReqId)
        let green = parseInt(relatedSellerReqStatus[0]?.green || 0)

        let greenColor = "rgba(117, 217, 117, 0.6)"
        let redColor = "rgba(254, 121, 104, 0.7)"
        let yellowColor = "rgba(234, 239, 44, 0.7)"

        let backgroundColor = redColor
        if(green == relatedBuyerReqItems.length){
            backgroundColor = greenColor
        } else if(green === 0){
            backgroundColor = redColor
        } else {
            backgroundColor = yellowColor
        }
        
        return (
            <>
                {reqDataLoading ? (
                    <div className='flex justify-content-center'>
                        <Skeleton shape="circle" size="30px" className='p-skeleton-circle'></Skeleton>
                    </div>
                ) : (
                    <div className='flex justify-content-center'>
                        <a href={`/send_requisition/${row.buyerReqId}`} target="_blank"><Button icon='pi pi-file-edit' className="circular-button  glass-icon-button" style={{ width: "30px", height: "30px", cursor: "pointer", borderWidth: '0', backgroundColor: backgroundColor, color: "#818181"}} rounded /></a>
                    </div>
                )}
            </>
        )
    }

    const quotesTemplate = (row) => {
        let relatedBuyerQuoteStatus = buyerQuoteStatus.find((el)=> el.buyerReqId == row.buyerReqId)

        const query = {
            red: relatedBuyerQuoteStatus?.noQuotationCount || 0,
            yellow: relatedBuyerQuoteStatus?.pendingQuotationCount || 0,
            green: relatedBuyerQuoteStatus?.activeQuotationCount || 0,
            total: relatedBuyerQuoteStatus?.totalBuyerReqItems,
        }

        let meterValues = [
            { color: '#75d975b3', value: query.green / query.total * 100},
            { color: '#eaef2cb3', value: query.yellow / query.total * 100},
            { color: '#fe7968b3', value: query.red / query.total * 100}
        ]
        meterValues = meterValues.filter(eachValue => eachValue.value > 0)

        return (
            <>
                {reqDataLoading ? (
                    <Skeleton width="90px" height="35px"></Skeleton>
                ) : (
                    <div className='buyer-quotes-metergroup'>
                        <MeterGroup values={meterValues} onClick={() => {setVisibleQuotes(true); setSelectedReq({ ...row });}}/>
                    </div>
                )}
            </>
        )
    }

    const buyerPoTemplate = (row) => {
        const relatedBuyerPOs = buyerPOData?.buyerPOs?.filter(eachBuyerPO => eachBuyerPO?.buyerReqId === row?.buyerReqId)
        let relatedBuyerPOStatus = buyerPOStatus.find((eachBuyerPO) => eachBuyerPO.buyerReqId == row.buyerReqId);
        
        const query = { 
            red: relatedBuyerPOStatus?.noPOCount || 0,
            yellow: relatedBuyerPOStatus?.pendingPOCount || 0,
            green: relatedBuyerPOStatus?.activePOCount || 0,
            total: relatedBuyerPOStatus?.totalBuyerReqItems,
        }

        let meterValues = [
            { color: '#75d975b3', value: query.green / query.total * 100},
            { color: '#eaef2cb3', value: query.yellow / query.total * 100},
            { color: '#fe7968b3', value: query.red / query.total * 100}
        ]
        meterValues = meterValues.filter(eachValue => eachValue.value > 0)

        return (
            <>
                {
                    reqDataLoading ?
                        <Skeleton width="90px" height="35px"></Skeleton>
                    :
                        // <Bar query={query} disabled={!relatedBuyerPOs?.length} onClick={() => { setVisibleBuyerpo(true); setSelectedReq({ ...row }) }} />
                        <div className={`buyer-quotes-metergroup ${!relatedBuyerPOs?.length ? 'disabled' : ''}`}>
                            <MeterGroup values={meterValues} disabled={!relatedBuyerPOs?.length} onClick={() => { setVisibleBuyerpo(true); setSelectedReq({ ...row }) }} />
                        </div>
                }
            </>
        )
    }

    const poPunchTemplate = (row) => {
        const relatedBuyerPOs = buyerPOData?.buyerPOs?.filter(eachBuyerPO => eachBuyerPO?.buyerReqId === row?.buyerReqId && eachBuyerPO?.statusId === 3)
        const relatedPOPunches = poPunchData?.poPunch?.filter(eachPOPunch => eachPOPunch?.buyerReqId === row?.buyerReqId && eachPOPunch?.statusId === 1)

        const relatedPOPunchStatus = POPunchStatus.find(eachPOPunchStatus => eachPOPunchStatus.buyerReqId === row.buyerReqId)
        let backgroundColor = "rgba(254, 121, 104, 0.7)"
       
        if (relatedPOPunchStatus){
            if (relatedPOPunchStatus.scheduleDateStatus === "red"){
                backgroundColor = "rgba(254, 121, 104, 0.7)"
            }
            if (relatedPOPunchStatus.scheduleDateStatus === "yellow"){
                backgroundColor = "rgba(234, 239, 44, 0.7)"
            }
            if (relatedPOPunchStatus.scheduleDateStatus === "green"){
                backgroundColor = "rgb(117, 217, 117, 0.6)"
            }
        }

        return (
            <>
                {reqDataLoading ? (
                    <div className='flex justify-content-center'>
                        <Skeleton shape="circle" size="30px" className='p-skeleton-circle'></Skeleton>
                    </div>
                ) : (
                    <div className='flex justify-content-center'>
                        <Button label={relatedPOPunches?.length ? relatedPOPunches.length : "0"} className="circular-button" style={{ width: "30px", height: "30px", borderWidth: '0', backgroundColor: backgroundColor , color: "#818181"}} rounded disabled={!relatedBuyerPOs?.length} onClick={() => handlePOPunchClick({ ...row })} />
                    </div>
                )}
            </>
        )
    }

    const sellerPoTemplate = (row) => {
        const relatedPOPunches = poPunchData?.poPunch?.filter(eachPOPunch => eachPOPunch?.buyerReqId === row?.buyerReqId && eachPOPunch?.statusId === 1) || []

        const relatedSellerPOStatus = sellerPOStatus?.find(eachSellerPOStatus => eachSellerPOStatus.buyerReqId === row.buyerReqId)

        const query = { 
            red: relatedSellerPOStatus?.noPOCount || 0,
            yellow: relatedSellerPOStatus?.pendingPOCountWithPendingApproval || 0,
            orange: relatedSellerPOStatus?.pendingPOCountWithUnSentEmail || 0,
            green: relatedSellerPOStatus?.activePOCount || 0, 
            total : relatedSellerPOStatus?.totalBuyerReqItems,
        }

        let meterValues = [
            { color: '#75d975b3', value: query.green / query.total * 100},
            { color: '#f5a623b3', value: query.orange / query.total * 100},
            { color: '#eaef2cb3', value: query.yellow / query.total * 100},
            { color: '#fe7968b3', value: query.red / query.total * 100},
        ]
        meterValues = meterValues.filter(eachValue => eachValue.value > 0)

        return (
            <>
                {
                    reqDataLoading ?
                        <Skeleton width="90px" height="35px"></Skeleton>
                        :
                        // <Bar query={query} style={{ width: "30px", height: "30px" }} disabled={relatedPOPunches.length === 0} onClick={() => { setVisibleSellerpo(true); setSelectedReq({ ...row }) }} />
                        <div className={`buyer-quotes-metergroup ${relatedPOPunches.length === 0 ? 'disabled' : ''}`}>
                            <MeterGroup values={meterValues} disabled={relatedPOPunches.length === 0} onClick={() => { setVisibleSellerpo(true); setSelectedReq({ ...row }) }}/>
                        </div>
                }
            </>
        )
    }

    const actionBodyTemplate = (row) => {
        const filteredBuyerReqItems = buyerRequirementItemsData.filter((eachItem) => eachItem.buyerReqId === row.buyerReqId)

        return (
            <div className='req-action-Body'>
                <Menu model={actionMenuItems} popup menuRef={requirementActionMenu} />
                <i className="pi pi-bars" style={{ fontSize: "1rem", cursor: "pointer" }} onClick={(e) => { requirementActionMenu.current.toggle(e); setSelectedReq({ ...row, buyerReqItems: filteredBuyerReqItems }) }}></i>
            </div>
        )
    }

    const handleDocNoClick = (products) => {
        setBuyerReqDisplayProducts(products)
        setVisibleReqDetails(true)
    }

    const getDocNoBody = (row) => {
        const date = moment(row.createdAt).format( DATE_TIME_FORMAT)
        const relatedOrderType = orderTypes.find((eachOrderType) => eachOrderType.orderTypeId === row.orderTypeId)
        const buyerReqId = row.buyerReqId
        let allProducts = []

        buyerRequirementItemsData?.filter((eachReqItem) => {
            if (eachReqItem.buyerReqId === buyerReqId) {
                if (materilProductsData.length){
                    materilProductsData.find((eachProduct) => {
                        if (eachProduct.buyerReqItemId === eachReqItem.buyerReqItemId) {
                            const relatedBuyerRateContractId = eachReqItem?.buyerRateContractId
                            const itemQty = eachReqItem?.qty
                            const relatedOrderTypeId = buyerRequirementData.find((req) => req.buyerReqId === buyerReqId);
                            const relatedOrderType = orderTypes.find((eachOrderType) => eachOrderType.orderTypeId === relatedOrderTypeId?.orderTypeId)
                            allProducts.push({ ...eachProduct, buyerRateContractId: relatedBuyerRateContractId, orderTypeId: relatedOrderTypeId?.orderTypeId, orderType: relatedOrderType?.orderType, createdAt: date, docNo: row.docNo, qty: itemQty });
                        }
                    })
                }
            }
        })

        return (
            <div className='req-no-container' style={{ position: "relative" }}>
                <div className='flex flex-row justify-content-center align-items-center'>
                    {
                        row?.docNo ?
                            <>
                                <p className='doc-no requirement-details-tooltip' style={{ cursor: "pointer" }} onClick={() => handleDocNoClick(allProducts)}>{row.docNo}</p>
                                <CopyToClipboard text={row.docNo} />
                            </>
                            : ""
                    }
                </div>
                {/* <p className='flex justify-content-center date'>{relatedOrderType.orderType}</p> */}
                <p className='mr-4 date'>{date} {relatedOrderType?.orderType[0]}</p>
                <Tooltip target=".requirement-details-tooltip" position='top'>
                    <span>View requirement details</span>
                </Tooltip>
            </div>
        )
    }

    const getCompanyBody = (row) => {
        let buyerName = ""
        if (row["buyer.firstName"]) {
            buyerName = row["buyer.firstName"]
        }
        if (row["buyer.lastName"]) {
            buyerName += " " + row["buyer.lastName"]
        }

        let companyShortName = getCompanyShortName(row["company.companyName"])
        return (
            <div>
                <PMCompanyName companyName={companyShortName} companyId={row.companyId}/>
                {/* <div className='company-short-name'>{companyShortName}</div> */}
                <div className='date'>{row["buyerCompanyBranch.branchName"]}</div>
                <div className='date mt-1'>{buyerName}</div>
            </div>
        )
    }

    const getKamBody = (row) => {
        let kamName = ""
        if (row["kam.firstName"]) {
            kamName = row["kam.firstName"]
        }
        if (row["kam.lastName"]) {
            kamName += " " + row["kam.lastName"]
        }

        if (kamName) {
            return (<div>
                {/* <p className='m-0'>{`${kamName}`}</p> */}
                <PMUserName userName={kamName} userId={row.createdBy}/>
                <p className=' m-0 date'>{row["pmCompanyBranch.branchName"]}</p>
            </div>)
        }
    }

    const getProductBody = (row) => {
        const buyerReqId = row.buyerReqId
        let productNamesListWithDuplicates = []
        let productNamesList = []

        buyerRequirementItemsData?.filter((eachReqItem) => {
            if (eachReqItem.buyerReqId === buyerReqId) {
                materilProductsData.find((each) => {
                    if (each.buyerReqItemId === eachReqItem.buyerReqItemId) {
                        const productName = each.productName
                        if (productNamesList.includes(productName)) {
                            productNamesListWithDuplicates.push(productName)
                        } else {
                            productNamesList.push(productName)
                        }
                    }
                })
            }
        })

        if (productNamesList.length > 0 && productNamesListWithDuplicates.length > 0) {
            const totalProductNamesStr = `${productNamesList.join(", ")}, ${productNamesListWithDuplicates.join(", ")}`
            const displayProductNameStr = `${productNamesList.slice(0, 6).join(", ")} & ${productNamesList.slice(6).length + productNamesListWithDuplicates.length} more items`

            return (
                <>
                    <Tooltip target={`.custom-tool-tip-${buyerReqId}`} position="top" autoHide className='post-req-tooltip' style={{ maxWidth: "600px" }} >
                        <p className='m-0'>{totalProductNamesStr}</p>
                    </Tooltip>
                    <p className={`custom-tool-tip-${buyerReqId}`} style={{ margin: "0px" }} >
                        {displayProductNameStr}
                    </p>
                </>
            )
        }
        return (productNamesList.length > 6 ? `${productNamesList.slice(0, 6).join(", ")} & ${productNamesList.slice(6).length} more items` : productNamesList.join(", "))
    }

    const smartFilterBody = () => {
        if(isSmartSearchApplicable){
            return(
                <img src={SmartFilterActiveImg} style={{width: "25px", cursor: 'pointer', backgroundImage: 'radial-gradient(circle at top left, #cad4ff 2%, #ffffff00)' }} onClick={() => handleSmartFilter()}/>
            )
        } else {
            return(
                <img src={SmartFilterImg} style={{width: "25px", cursor: 'pointer'}} onClick={() => handleSmartFilter()}/>
            )
        }
    }

    const handleSmartFilter = async () => {
        setIsSmartSearchApplicable(true)
        let requirementParams = {
            ...paginationParams,
            pageNo: 0,
            isSmartSearchApplicable: true,
        }

        dispatch(fetchRequirement(requirementParams))
    }

    const handleSearchTabDisplay = () => {
        dispatch(setIsSearchVisible(!isSearchVisible))
    }

    const tableColumnsPage = [
        {
            header: smartFilterBody,
            body: actionBodyTemplate,
        },
        {
            header: 'Req. No.',
            body: getDocNoBody
        },
        {
            header: 'Kam',
            body: getKamBody,
            style: { minWidth: "180px" }
        },
        {
            header: 'Products',
            body: getProductBody,
            style: { minWidth: "230px" }
        },
        {
            header: 'Company',
            field: 'company.companyName',
            body: getCompanyBody,
            style: { minWidth: "180px" }
        },
        {
            header: 'Seller Reqs',
            field: 'Send Req',
            body: sendReqTemplate
        },
        {
            header: 'Quotes',
            field: 'Quotes',
            style: { minWidth: "95px" },
            body: quotesTemplate
        },
        {
            header: 'Buyer PO',
            field: 'Buyer PO',
            style: { minWidth: "95px" },
            body: buyerPoTemplate
        },
        {
            header: 'PO Punch',
            field: 'PO Punch',
            body: poPunchTemplate
        },
        {
            header: 'Seller PO',
            field: 'Seller PO',
            style: { minWidth: "95px" },
            body: sellerPoTemplate
        },
    ]

    const updatedApprovalInstancesData = JSON.parse(JSON.stringify(approvalInstancesData))

    let company = {}
    if (selectedReq.buyerReqId){
        company.companyId = selectedReq.companyId
        company.tags = selectedReq["companies.tags"]
    }

    const actionButtons = [
        {
            icon: "pi pi-shopping-cart",
            label: "Post Requirement",
            permissions: [5],
            command: () => navigate("/postrequirement")
        },
        {
            icon: "pi pi-filter",
            label: "Filter",
            command: () => handleSearchTabDisplay(),
            className: isSearchActive ? "active-group-button" : ""
        },
    ]

    return (
        <div className="requirement-layout flex flex-column">
            <div className="flex flex-column md:flex-row justify-content-between">
                <h4 className="mx-2 mt-1 mb-2 md:m-2">REQUIREMENTS</h4>
                {/* <div className="flex gap-2 justify-content-end mb-2">
                    <Button icon="pi pi-shopping-cart" className="h-2rem p-2 action-btn hover:surface-400 hover:text-700 surface-300" label="Post Requirement" onClick={() => { navigate(`/postrequirement`) }} permissions={[5]} />
                    <Button icon="pi pi-filter" className={`h-2rem  p-2 action-btn hover:surface-400 hover:text-700 surface-300 ${isSearchActive ? 'search-filter-active' : ''}`} label="Filter" onClick={handleSearchTabDisplay} />
                </div>
                    <Button icon="pi pi-filter" className="h-2rem  p-2 action-btn hover:surface-400 hover:text-700 surface-300" label="Filter" onClick={() => { setIsSearchVisible(!isSearchVisible) }} />
                </div> */}
                <div className="mb-2">
                    <ButtonGroup buttons={actionButtons} />
                </div>         
            </div>
            <div className='flex flex-row'>
                <div className="requirement-table" style={{ order: "1", width: isSearchVisible && !isMobileDevice ? "82%" : "100%" }}>
                    <div className='p-card mb-0'>
                        <div className="flex-grow-1" >
                            <Table
                                lazy
                                page={paginationParams.pageNo}
                                onPageChange={(e) => handlePageChange(e)}
                                totalRecords={paginationParams.totalRecords}
                                tableColumns={tableColumnsPage}
                                data={buyerRequirementData}
                                rows={paginationParams.recordsPerPage}
                                scrollable={"true"}
                                scrollHeight="550px"
                                paginator
                                excessPagesFound={paginationParams.excessPagesFound}
                                loading={isLoading}
                            />
                        </div>
                    </div>
                </div>

                {isSearchVisible && !isMobileDevice &&
                    <div style={{ order: "2", width: "18%", paddingLeft: "10px" }} className="justify-content-end">
                        <SearchBar setIsSmartSearchApplicable={setIsSmartSearchApplicable} />
                    </div>
                }

                {isSearchVisible && isMobileDevice &&
                    <div style={{ order: "2", width: "18%", paddingLeft: "10px" }} className="justify-content-end">
                        <Sidebar position='right' visible={isSearchVisible} onHide={() => dispatch(setIsSearchVisible(false))}>
                            <SearchBar setIsSmartSearchApplicable={setIsSmartSearchApplicable}/>
                        </Sidebar>
                    </div>
                }
            </div>

            <Dialog header="ADD PRODUCT" visible={visibleAddProduct} style={{ width: '90vw', minHeight: "50vh", }} onHide={() => setVisibleAddProduct(false)}>
                <AddProduct requirement={selectedReq} setVisibleAddProduct={() => setVisibleAddProduct(false)} buyerPOData={buyerPOData} buyerRequirementItems={buyerRequirementItemsData} company={company} />
            </Dialog>

            <Dialog header="DUPLICATE REQUIREMENT" visible={visibleDuplicateBuyerReqDate} style={{ width: '30vw', minHeight: "30vh", }} onHide={() => setVisibleDuplicateBuyerReqDate(false)}>
                <DuplicateBuyerReqDateModal handleDuplicateBuyerRequirement={handleDuplicateBuyerRequirement} selectedReq={selectedReq} setSelectedReq={setSelectedReq} setDuplicateBuyerReqLoading={setDuplicateBuyerReqLoading} onCancel={handleDuplicateBuyerReqDateCancellation} />
            </Dialog>

            <Dialog header="REQUIREMENT DETAILS" visible={visibleReqDetails} style={{ width: '90vw', minHeight: "50vh", }} onHide={() => setVisibleReqDetails(false)}>
                <ReqDetailsModal buyerReqDisplayProducts={buyerReqDisplayProducts} />
            </Dialog>

            <Dialog header="EDIT MATERIAL QTY" visible={visibleEditBuyerReqItemQty} style={{ width: '70vw', minHeight: "50vh", }} onHide={() => setVisibleEditBuyerReqItemQty(false)}>
                <EditBuyerReqItemQty 
                    buyerReqDisplayProducts={buyerReqDisplayProducts} 
                    selectedReq={selectedReq} 
                    setVisibleEditBuyerReqItemQty={setVisibleEditBuyerReqItemQty} 
                    buyerQuotes={buyerQuoteData?.buyerQuotes} 
                />
            </Dialog>

            <QuotationModal 
                selectedReq={selectedReq} 
                approvalInstances={updatedApprovalInstancesData}
                buyerQuotes={buyerQuoteData?.buyerQuotes} 
                buyerQuoteItems={buyerQuoteData?.buyerQuoteItems || []} 
                buyerReqItems={buyerRequirementItemsData}
                sellerReqItems={sellerReqData?.sellerReqItems || []}
                materialDetails={materilProductsData} 
                buyerPOs={buyerPOData?.buyerPOs} 
                visibleQuotes={visibleQuotes} 
                setVisibleQuotes={setVisibleQuotes} 
                setIsPageLoading={setIsPageLoading}
            />

            <BuyerPoModal 
                selectedReq={selectedReq} 
                approvalInstances={updatedApprovalInstancesData}
                buyerQuotes={buyerQuoteData?.buyerQuotes} 
                buyerPOs={buyerPOData?.buyerPOs} 
                buyerPOItems={buyerPOData?.buyerPOItems} 
                materialDetails={materilProductsData} 
                sellerPOs={sellerPOData?.sellerPOs} 
                visibleBuyerpo={visibleBuyerpo} 
                setVisibleBuyerpo={setVisibleBuyerpo} 
            />
            
            <POPunchModal 
                selectedReq={selectedReq} 
                buyerPOs={buyerPOData?.buyerPOs} 
                visiblePOPunch={visiblePOPunch} 
                setVisiblePOPunch={setVisiblePOPunch} 
            />

            <SellerPoModal
                selectedReq={selectedReq} 
                approvalInstances={updatedApprovalInstancesData}
                sellerReqs={sellerReqData?.sellerReqs}
                buyerQuoteItems={buyerQuoteData?.buyerQuoteItems}
                buyerPOItems={buyerPOData?.buyerPOItems}
                buyerPOs={buyerPOData?.buyerPOs} 
                sellerPOs={sellerPOData?.sellerPOs} 
                sellerPOItems={sellerPOData?.sellerPOItems} 
                materialDetails={materilProductsData} 
                sellerPIPunch={piPunchData?.sellerPIPunch} 
                visibleSellerpo={visibleSellerpo} 
                sellerCompanyDetails={sellerCompanyDetails}
                setVisibleSellerpo={setVisibleSellerpo}
            />

            <Loading visible={isPageLoading || duplicateBuyerReqLoading} />
        </div>
    )
}

export default NewRequirementBuyer; 